import { useEffect, useRef, useState } from "react";
import { AUTH_BASE_URL } from "../config";

const AcceptInvite = () => {
  const initiatedRef = useRef(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (initiatedRef.current) return;

    const rawToken = new URLSearchParams(window.location.search).get("token");
    const token = typeof rawToken === "string" && /^[a-zA-Z0-9_-]{1,128}$/.test(rawToken.trim())
      ? rawToken.trim()
      : null;

    if (!token) {
      setErrorMessage("Invite token missing or invalid. Please use the invite link from your email.");
      return;
    }

    initiatedRef.current = true;
    // Keep the token around in case the callback URL loses it across the OIDC round-trip.
    sessionStorage.setItem("inviteToken", token);

    // Sign in via the backend OIDC flow, returning to the callback with the token preserved.
    const callback = `${window.location.origin}/invite/callback?token=${encodeURIComponent(token)}`;
    window.location.href = `${AUTH_BASE_URL}/auth/login?returnUrl=${encodeURIComponent(callback)}`;
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-theme-primary">
      <div className="bg-theme-card-solid border border-border rounded-2xl shadow-xl p-10 w-96 text-center flex flex-col items-center gap-4">
        <div className="logo-wordmark logo-wordmark-lg items-center">
          <span className="logo-wordmark-text logo-wordmark-text-gradient">AXARIS™</span>
          <span className="logo-wordmark-sub text-content-muted">By Cloud Guidant</span>
        </div>
        {errorMessage ? (
          <>
            <p className="text-red-400">{errorMessage}</p>
            <a href="/login" className="text-accent-cyan hover:underline">Return to Login</a>
          </>
        ) : (
          <>
            <p className="text-content-secondary">Please wait while we set up your account...</p>
            <div className="animate-spin rounded-full border-2 border-transparent border-t-accent-cyan border-r-accent-purple h-8 w-8"></div>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptInvite;
